import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CollabCodeEditorModule } from '@portal-core/code-editor/components/collab-code-editor/collab-code-editor.module';
import { CollabDocBarModule } from '@portal-core/collab/components/collab-doc-bar/collab-doc-bar.module';
import { FlarePropertiesEditorModule } from '@portal-core/file-properties/components/flare-properties-editor/flare-properties-editor.module';
import { FlareTextEditorModule } from '@portal-core/project-files/components/flare-text-editor/flare-text-editor.module';
import { ProjectFilesAccessErrorMessageModule } from '@portal-core/project-files/components/project-files-access-error-message/project-files-access-error-message.module';
import { FlareCollabEditorComponent } from './flare-collab-editor.component';

@NgModule({
  declarations: [
    FlareCollabEditorComponent
  ],
  imports: [
    CollabCodeEditorModule,
    CollabDocBarModule,
    CommonModule,
    FlareTextEditorModule,
    MatButtonModule,
    MatTooltipModule,
    MatDividerModule,
    MatIconModule,
    ProjectFilesAccessErrorMessageModule,
    FlarePropertiesEditorModule
  ],
  exports: [
    FlareCollabEditorComponent
  ]
})
export class FlareCollabEditorModule { }
